import { render, staticRenderFns } from "./table-pager.vue?vue&type=template&id=baa91b94&scoped=true"
import script from "./table-pager.vue?vue&type=script&lang=js"
export * from "./table-pager.vue?vue&type=script&lang=js"
import style0 from "./table-pager.vue?vue&type=style&index=0&id=baa91b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa91b94",
  null
  
)

export default component.exports